<template>
    <v-alert
        :value="visible"
        type="warning"
        icon="priority_high"
        color="amber darken-2"
        class="shape cutie text-caption"
    >
        <slot />
    </v-alert>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'AlertWarning',
})
export default class AlertWarning extends Vue {
    @Prop({ default: true }) visible: boolean;
}
</script>
